<template>
    <div class="lms__superadmin_customer_edit_options">
        <div class="lms__superadmin_customer_edit_options_ebssettings">
            <component-title
                :size="'medium'"
                :underline="true"
            >
                EBS settings
            </component-title>
            <form-checkbox
                :name="'lms-superadmin-customer-edit-options'"
                :label="'Hide events catalogue from learners'"
                v-model="customerOptionsEBSHideEventsCatalogue"
            >Checking this option will cause that events catalogue won't be visible for learners.
            </form-checkbox>
        </div>
        <template v-if="customerHasCCSService">
            <div class="lms__superadmin_customer_edit_options_ccssettings">
                <component-title
                    :size="'medium'"
                    :underline="true"
                >
                    CCS settings
                </component-title>
                <form-radio-horizontal
                    :disabled="customerOptionsCCSState === 'open'"
                    :name="'lms-superadmin-customer-edit-options-open'"
                    :label="'Can offer courses to other organisations'"
                    :items="[
                        {
                            name: 'No',
                            value: false
                        },
                        {
                            name: 'Yes',
                            value: true
                        }
                    ]"
                    :value="customerOptionsCCSOpen"
                    @input="setCustomerOptionsCCSOpen"
                >
                    <template v-if="customerOptionsCCSState === 'open'">Me Learning can offer to all current and new customers</template>
                </form-radio-horizontal>
                <form-select
                    :limit-active="true"
                    :limit-items="4"
                    :name="'lms-superadmin-customer-edit-options-allowedcustomers'"
                    :disabled="!customerOptionsCCSOpen || customerOptionsCCSState === 'open'"
                    :placeholder="!customerOptionsCCSOpen ? 'No organisations' : undefined"
                    :label="'Select organisation'"
                    :value="customerOptionsCCSAllowedCustomers"
                    :data-vv-as="'customer'"
                    :multiple="true"
                    :get-pagination-getter="'getLmsSuperadminCustomersPagination'"
                    :get-items-getter="'getLmsSuperadminCustomersMappedIdNameStatus'"
                    :get-items-getter-mapped="'getLmsSuperadminCustomersMappedLabelValue'"
                    :get-items-dispatch="'lmsSuperadminCustomersGet'"
                    :items-excluded="[customerId]"
                    :item-name="['customer', 'customers']"
                    :table-labels="customerTableLabels"
                    :search-queryable="true"
                    @input="setCustomerOptionsCCSAllowedCustomers"
                    @input-table="setCustomerOptionsCCSAllowedCustomers"
                />
            </div>
        </template>
    </div>
</template>

<script>
import { performSubmitValidatePromise, validateBeforeRouteLeave } from '@/helpers/mixins'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import FormRadioHorizontal from '@/components/default/forms/FormRadioHorizontal'
import FormSelect from '@/components/default/forms/FormSelect'

export default {
  name: 'lms-superadmin-customer-edit-options',
  components: { FormSelect, FormRadioHorizontal, ComponentTitle, FormCheckbox },
  mixins: [validateBeforeRouteLeave, performSubmitValidatePromise],
  computed: {
    customerId () {
      return this.$route.params.id
    },
    customerTableLabels () {
      let labelsArr = []

      labelsArr.push({
        key: 'name',
        title: 'Name',
        type: 'string',
        sortable: true,
        queryable: true
      })

      return labelsArr
    },
    customerHasCCSService () {
      return this.$store.getters.getLmsSuperadminCustomerServicesByKey('CCS')
    },
    customerOptionsEBSHideEventsCatalogue: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerOptionsEBSHideEventsCatalogue
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerSetOptionsEBSHideEventsCatalogue', value)
      }
    },
    customerOptionsCCSOpen () {
      return this.$store.getters.getLmsSuperadminCustomerOptionsCCSOpen
    },
    customerOptionsCCSState () {
      return this.$store.getters.getLmsSuperadminCustomerOptionsCCSState
    },
    customerOptionsCCSAllowedCustomers () {
      return this.$store.getters.getLmsSuperadminCustomerOptionsCCSAllowedCustomers
    }
  },
  methods: {
    setCustomerOptionsCCSOpen (value) {
      if (!value) {
        this.$store.dispatch('lmsSuperadminCustomerSetOptionsCCSAllowedCustomers', [])
      }
      this.$store.dispatch('lmsSuperadminCustomerSetOptionsCCSOpen', value)
    },
    setCustomerOptionsCCSAllowedCustomers (value) {
      const oldValue = this.customerOptionsCCSAllowedCustomers

      this.$store.dispatch('lmsSuperadminCustomerSetOptionsCCSAllowedCustomers', value)

      if (value.length < oldValue.length) {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Organisation removed',
          status: 'success'
        })
      }
    }
  }
}
</script>
